module.exports = __webpack_public_path__ + "img/tax-declare-upload-ex.b4caa024.jpg";